import { render, staticRenderFns } from "./seniorOrderMange.vue?vue&type=template&id=f161d83a&scoped=true&"
import script from "./seniorOrderMange.vue?vue&type=script&lang=js&"
export * from "./seniorOrderMange.vue?vue&type=script&lang=js&"
import style0 from "./seniorOrderMange.vue?vue&type=style&index=0&id=f161d83a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f161d83a",
  null
  
)

export default component.exports